export default __webpack_public_path__ + "static/bg_black-37cba55c949ee85435fee137a3836561.webp";